import type { LocalizationDictionary } from "@slot/game-shell";

// This title's words, in two places: this compiled English (the boot-time fallback for what its code shows), and the
// served `game.<locale>.json` in `assets-src/game-shared-visuals/localization/`, merged over the shell's dictionary,
// which also carries the info page's and the intro cards' text. The parity test holds them together.

export const gameEnDictionary: LocalizationDictionary = {
  "featuretrigger.title": "You Have Won",
  "featuretrigger.subtitle": "Free Spins",
  "featurefinished.title": "You Won",
  "featurefinished.subtitle": "in Free Spins",
  "bigwin.big": "Big Win",
  "bigwin.mega": "Mega Win",
  "bigwin.huge": "Huge Win",
  "bigwin.epic": "Epic Win",
  "feature_purchase.free_spins_buy.title": "Bonus Buy",
  "feature_purchase.free_spins_buy.description": "Buy your way straight to the free-spins round.",
  "feature_purchase.secret_bonus.title": "Secret Bonus",
  "feature_purchase.secret_bonus.description": "More free spins than the Bonus Buy. Only while the Secret Bonus is on the board.",
  "secret_bonus.symbol": "SECRET\nBONUS",
};
